<template lang="pug">
	.instalacao__ajuda--wrapper 
		h2.instalacao__section_title Precisa de ajuda?
	
		p.instalacao__section_paragraph Em caso de dúvidas, 
			a(href="https://spc.xgen.com.br/spc/form_chat_cliente.html") clique aqui para entrar em contato com a nossa equipe. 
			br
			br
			|Para otimizar o atendimento, 
			a(href="https://anydesk.com/pt/downloads/thank-you?dv=win_exe") clique aqui para fazer o download da AnyDesk, 
			|ferramenta que nossos atendentes usarão para acessar sua máquina e te auxiliar. 
			br
			|Depois da instalação, é só informar para o atendente o código que aparece no centro da sua tela do AnyDesk.
			br
			br
			|Atendimento disponível de segunda a sexta-feira, das 8h às 19h.
	</template>
	
	<script>
	export default {
		name: "precisa_de_ajuda_tag",
		data: function() {
			return {
				BASE_URL: process.env.BASE_URL
			};
		}
	}
	</script>